"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExitRoomActionHandler = exports.ExitRoomActionArgs = void 0;
const __1 = require("../../..");
const Demand_1 = require("../../Demand");
const Registries_1 = require("../../state/Registries");
const ActionType_1 = require("../ActionType");
class ExitRoomActionArgs {
    constructor(roomId) {
        this.roomId = roomId;
        this.__type = ActionType_1.ActionType.ExitRoom;
        this.__typeName = "ExitRoom";
    }
}
exports.ExitRoomActionArgs = ExitRoomActionArgs;
let ExitRoomActionHandler = class ExitRoomActionHandler {
    activate(sequence, container, action) {
        const room = container.getRoom(action.args.roomId);
        (0, Demand_1.demand)(container.currentRoom === action.args.roomId, "WRONG_ROOM");
        (0, Demand_1.demand)(room.state === "Cleared", "CANNOT_EXIT_UNCLEARED_ROOM");
        container.emitEvent(sequence, container.nextActor, new __1.TurnEndedEventArgs());
        container.applyBattleLogText(sequence, container.nextActor, "ends turn");
        const exitSequence = sequence.pushSequence("parallel");
        for (const script of room.onExited) {
            Registries_1.RoomScripts.getItem(script.key).run(exitSequence, container, room, script.args);
        }
        for (const actor of room.actors) {
            container.disableActor(exitSequence, actor);
        }
        const eventSequence = sequence.pushSequence("parallel");
        container.emitEvent(eventSequence, container.adventure.id, new __1.RoomExitedEventArgs(room.id));
        for (const ally of container.allies) {
            container.emitEvent(eventSequence, ally, new __1.RoomExitedEventArgs(room.id));
        }
        container.currentRoom = 0;
    }
};
ExitRoomActionHandler = __decorate([
    Registries_1.Actions.register(ActionType_1.ActionType.ExitRoom)
], ExitRoomActionHandler);
exports.ExitRoomActionHandler = ExitRoomActionHandler;
